import React, { useEffect } from "react";
import ServicesList from "../components/services/ServicesList";
import ContactCTA from "../components/home/ContactCTA";

const ServicesPage = () => {
  useEffect(() => {
    document.title = "Our Services | Professional Service Associates";
  }, []);

  return (
    <>
      <div className="bg-psa-green-600 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center font-display">
            Our Services
          </h1>
        </div>
      </div>
      <ServicesList />
      <ContactCTA />
    </>
  );
};

export default ServicesPage;
